import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateSavedReportRightsForUserMutation } from "org/user/queries/useUpdateSavedReportRightsForUserMutation";

import { SavedReportRow } from "./useUserSavedReportsListTable";

interface UseRemoveSavedReportAccessRightUtilsProps {
    userId: number;
    selectedRows: Row<SavedReportRow>[];
    deselectAll: () => void;
}

export function useRemoveSavedReportAccessRightUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseRemoveSavedReportAccessRightUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdateSavedReportRightsForUserMutation();

    const removeAccessRightToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const removeAccessRight = async () => {
        const savedReportIds = selectedRows.map((row) => row.original.id);
        try {
            await mutateAsync({
                userId,
                data: { newUserId: null, savedReportIds },
            });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error("Failed to remove saved report access right:", error);
        }
    };

    return {
        removeAccessRightToolState,
        isRemoveAccessRightModalOpen: isModalOpen,
        openRemoveAccessRightModal: () => setIsModalOpen(true),
        closeRemoveAccessRightModal: () => setIsModalOpen(false),
        removeAccessRight,
        isRemovingAccessRight: isPending,
    };
}
